<template>
  <v-layout wrap>
    <v-flex sm12>
      <v-toolbar dense ref="aToolbar" flat>
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left-bold-outline</v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ $t('MASSEDIT_TITLE') }}
          <span class="subheading">({{ $t('MASSEDIT_NUMBER_INCLUDED', [numSelected]) }})</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items >
          <v-btn text color="primary" :disabled="!mItems.length" @click="onExecute()">{{ $t('MASSEDIT_RUN') }}</v-btn>
<v-btn v-if="isDebug" fab small color="grey lighten-3" class="btn-debug" @click="debug=!debug"><v-icon>mdi-bug-outline</v-icon></v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </v-flex>
    <v-flex sm12 v-if="debug">
{{ ids }}
<v-divider />
<!-- {{ selectedContacts }} -->
    </v-flex>
    <v-flex sm12>

      <v-container>
        <v-card>
          <v-card-text>

      <v-layout>
        <v-flex>

          <ContactMassEditItem
            v-for="(item, idx) in mItems"
            :key="idx"
            :idx="idx"
            :meItem="item"
            :hasAdd="idx==mItems.length-1"
            @add="addItem()"
            @remove="removeItem(idx)"
            :debug="debug"
          />

        </v-flex>
      </v-layout>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-container>

    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
// import Contact from "../services/Contact";
import ContactMassEditItem from './ContactMassEditItem'
import { MassEditItemModel } from '../models/MassEditItemModel'
import { json2xml } from 'xml-js';
import APISelection from './../services/Selection'
import Search from '../services/Search';

export default {
  name: 'ContactMassEdit',
  components: {
    ContactMassEditItem,
  },
  props: ['refToolbar'],
  data() {
    return {
      debug: false,
      mItems: [],
    }
  },
  computed: {
    ...mapGetters(['isDebug', 'exportIds', 'allToExport', 'contactsTotal', 'searchReq']),
    numSelected() {
      return this.allToExport ? this.contactsTotal - this.exportIds.length : this.exportIds.length
    },
  },

  watch: {},

  mounted() {
    this.refToolbar.$el.parentElement.appendChild(this.$refs.aToolbar.$el)
    this.mItems.push(new MassEditItemModel())
  },

  methods: {
    addItem() {
      this.mItems.push(new MassEditItemModel())
    },
    removeItem(idx) {
      idx > -1 && this.mItems.splice(idx, 1)
      if (!this.mItems.length) {
        this.addItem()
      }
    },
    onExecute() {
      const xml = this.buildXML()
// console.log(xml);return;
      new APISelection(this.$api).set(xml)
        .then(() => {
          this.$router.go(-1)
        })
    },
    buildXML() {
      const s_query = new Search(this.$api).buildSearchBlockToJS()
console.log('s_query', s_query)

      // Flags - deselect - no_account
      // API: Selection:set
/*
      xml = `
<request>
  <selection type="list">
    <include>
      <aitem id="38269"/>
    </include>
  </selection>
  <set>
    <fields/>
    <categories>
      <cat id="10" event="del" catid="560"/>
    </categories>
    <freefields/>
  </set>
</request>
`
*/
      const jsonObject = {
        request: {
          selection: {
            _attributes: {
              type: this.searchReq.type,
            },
            // include: {
            //   aitem: [
            //     // {
            //     //   _attributes: {
            //     //     id: '38269'
            //     //   }
            //     // }
            //   ]
            // }
          },
          set: {
            fields: {

            },
            categories: {
              cat: [
                // {
                //   _attributes: {
                //     id: '10',
                //     event: 'del',
                //     catid: '560'
                //   }
                // }
              ]
            },
            freefields: {
              ff: [
                // {
                //   _attributes: {
                //   }
                // }
              ]
            }
          }
        }
      }
      // this.selectedContacts.forEach(a => {
      //   jsonObject.request.selection.include.aitem.push({
      //     _attributes: {
      //       id: a.id
      //     }
      //   })
      // });
      if (this.allToExport) { // exclusive
        jsonObject.request.selection._attributes = {
          'type': this.searchReq.type
        }
        if (this.searchReq.val == 'new' || this.searchReq.val == 'all') {
          jsonObject.request.selection.query = s_query
        } else {
          if (this.searchReq.type !== 'simple') {
            jsonObject.request.selection.query = {
              _attributes: {
                id: this.searchReq.val
              }
            }
          }
        }
        jsonObject.request.selection.exclude = {
          aitem: [
            // {
            //   _attributes: {
            //     id: '41341'
            //   }
            // }
          ]
        }
        if (this.exportIds.length) {
          this.exportIds.forEach(a => {
            jsonObject.request.selection.exclude.aitem.push({
              _attributes: {
                id: a
              }
            })
          });
        } else {
          jsonObject.request.selection._attributes.search_string = this.searchReq.val
        }
      } else { // inclusive
        jsonObject.request.selection._attributes = {
          'type': 'list'
        }
        jsonObject.request.selection.include = {
          aitem: [
            // {
            //   _attributes: {
            //     id: '41341'
            //   }
            // }
          ]
        }
        if (this.exportIds.length) {
          this.exportIds.forEach(a => {
            jsonObject.request.selection.include.aitem.push({
              _attributes: {
                id: a
              }
            })
          });
        }
      }
      this.mItems.forEach(a => {
        if (a.field) {
          if (a.field.type == 'field') {
            jsonObject.request.set.fields[a.field.id] = a.command.id != 'clear'
              ? (a.field.datatype === 'checkbox'
                ? (a.command.id === 'select' ? 1 : +a.value)
                : a.value)
              : ''
          }
          if (a.field.type == 'catlist') {
            jsonObject.request.set.categories.cat.push({
              _attributes: {
                id: a.field.id,
                event: a.command.id === 'clear' ? 'del' : a.command.id,
                catid: a.command.id != 'clear' ? a.value : ''
              }
            })
          }
          if (a.field.type == 'free') {
            jsonObject.request.set.freefields.ff.push({
              _attributes: {
                id: a.field.id
              },
              _text: a.command.id != 'clear' ? a.value : ''
            })
          }
        }
      });
      return json2xml(jsonObject, {compact: true})
    }
  },

  beforeDestroy() {
    this.$refs.aToolbar.$el.remove()
  },
}
</script>

<style>

</style>
